var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeafA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 300.216,
    height: 472.452,
    viewBox: "0 0 300.216 472.452",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "leaf 7",
    d: "M86.6477 47.5319C93.4269 47.5319 80.837 6.73359 107.469 0.588225C136.281 -6.05995 133.133 45.8029 143.786 47.5319C149.597 48.475 162.671 28.1765 179.377 36.8849C197.886 46.5332 168.58 76.4976 183.735 90.8463C192.935 99.5574 216.703 54.3562 242.81 58.1795C276.948 63.1789 186.64 161.019 217.388 174.085C238.452 183.036 263.972 136.775 294.38 147.469C329.729 159.9 191.24 265.069 232.157 273.054C250.406 276.616 270.863 253.73 279.853 265.069C290.022 277.894 277.706 301.956 262.421 316.852C252.737 326.289 222.473 343.469 218.841 356.052C209.894 387.053 189.057 410.909 158.313 415.974C158.241 415.986 158.168 415.998 158.096 416.01C155.055 417.682 169.644 471.294 153.229 472.445C142.575 473.192 155.266 417.812 146.45 416.889C113.957 416.028 89.2739 384.399 78.658 370.329C63.7448 350.564 17.2871 343.728 27.5722 321.208C32.4655 310.494 48.5377 318.019 52.5098 306.93C59.5311 287.331 -18.9442 254.409 4.32944 213.77C25.3932 176.99 49.3436 207.045 52.5098 201.429C62.1943 184.249 -0.679443 158.144 14.9824 132.708C36.2883 98.1056 57.2315 131.865 68.7314 112.382C77.8715 96.8957 22.3773 74.9152 48.1518 44.3862C61.2259 28.9004 79.8685 47.5319 86.6477 47.5319Z",
    fill: "url(#paint0_linear_0_65)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_65",
    x1: 150.108,
    y1: 472.452,
    x2: 150.108,
    y2: -2.29223e-8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A35C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4DCD0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafA);
export default __webpack_public_path__ + "static/media/leaf-a.c72fa4e1a4e406da4d6a8b86329fe065.svg";
export { ForwardRef as ReactComponent };